import { Alert, AlertDescription, Skeleton } from '@sitewise/ui';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';


import { vendorConsumeLink } from '../../api/vendor-auth.js';
import { ApiError } from '../../lib/api-client.js';

import { AuthShell } from './auth-shell.js';

export function VendorCallbackPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: () => vendorConsumeLink(token),
    onSuccess: () => navigate('/vendor/work', { replace: true }),
  });

  useEffect(() => {
    if (token) mutation.mutate();
    // intentionally omit `mutation` from deps to fire exactly once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (!token) {
    return (
      <AuthShell title="Missing link">
        <Alert variant="danger">
          <AlertDescription>
            This sign-in link is missing required parameters. Request a new link from the
            vendor sign-in page.
          </AlertDescription>
        </Alert>
      </AuthShell>
    );
  }

  if (mutation.error) {
    return (
      <AuthShell
        title="Sign-in failed"
        footer={
          <Link to="/vendor" className="text-fg hover:underline">
            Request a new link
          </Link>
        }
      >
        <Alert variant="danger">
          <AlertDescription>
            {mutation.error instanceof ApiError
              ? mutation.error.message
              : 'This sign-in link is invalid or expired.'}
          </AlertDescription>
        </Alert>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Signing you in…">
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-9 w-full" />
    </AuthShell>
  );
}
